import {
    getBroker,
    postBroker,
    putBroker,
    deleteBroker,
} from "@services/broker";
import i18n from "@/i18n";

const state = {
    loading: false,
    brokerData: [],
    brokerHeader: [
        { text: "ID", value: "id", align: "left" },
        {
            text: i18n.t("common.table.brokerName"),
            value: "broker_name",
            align: "left",
        },
        {
            text: i18n.t("common.table.description"),
            value: "description",
            align: "left",
        },
        {
            text: i18n.t("common.table.createdAt"),
            value: "created_at",
            align: " d-none",
        },
        {
            text: i18n.t("common.table.updatedAt"),
            value: "updated_at",
            align: " d-none",
        },
        { text: i18n.t("common.table.actions"), value: "action", align: "left" },
    ],
    updated: false,
    returnMsg: "",
    csvFields: {
        ID: "id",
        "Broker Name": "broker_name",
        Description: "description",
    },
};

const actions = {
    getBrokerAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        getBroker().then((res) => {
            commit("UPDATE_BROKER", res.data);
            commit("UPDATE_LOADING", false);
            commit("UPDATE_STATUS", false);
        });
    },
    postBrokerAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);
        let snackbar = {
            message: i18n.t("settings.broker.bookAddingInformation"),
            color: "orange",
            btnName: "Close",
            status: true,
            timeout: 15000,
        };
        commit("UPDATE_SNACKBAR", snackbar, { root: true });

        postBroker(params)
            .then((res) => {
                commit("UPDATE_LOADING", false);
                commit("UPDATE_STATUS", true);
                commit("UPDATE_MSG", res.data.msg);
            })
            .catch(({ response }) => {
                if (response.status == 409) {
                    let snackbar = {
                        message:
                            response.data.msg +
                            i18n.t("settings.broker.nameConflict"),
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 3000,
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_LOADING", false);
                }
            });
    },
    putBrokerAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);
        putBroker(params)
            .then((res) => {
                commit("UPDATE_STATUS", true);
                commit("UPDATE_MSG", res.data.msg);
                commit("UPDATE_LOADING", false);
            })
            .catch(() => {
                commit("UPDATE_LOADING", false);
            });
    },
    deleteBrokerAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        deleteBroker(params)
            .then((res) => {
                commit("UPDATE_LOADING", false);
                commit("UPDATE_MSG", res.data.msg);
                commit("UPDATE_STATUS", true);
            })
            .catch(({ response }) => {
                if (response.status == 406) {
                    let snackbar = {
                        message:
                            response.data.msg +
                            i18n.t("settings.broker.deleteWarning"),
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 4000,
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_LOADING", false);
                }
            });
    },
};

const mutations = {
    /**
     * Update brokers
     *
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_BROKER(state, data) {
        state.brokerData = data;
    },
    /**
     * Update loading
     *
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_STATUS(state, data) {
        state.updated = data;
    },
    UPDATE_MSG(state, data) {
        state.returnMsg = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
